import React, { useState,useRef } from 'react';
import {InpDataList} from '@gull'
import { useTranslate } from 'react-redux-multilingual'

const SelectDataListSearch = (props) => {
    const t = useTranslate();
    const inputRef = useRef('')
    const listRef = useRef('')
    const [datas,setDatas] = useState(props.datas)
        
    const handleClickFilter = (id,label,nameInput,reference,quota) => { //quota est utilisé uniquement dans le cas d'un select d'article 
        if(props.writeLabel){
            if(props.from && props.from=="selectEcomConnect") {
                switch (label) {
                    case 'name':
                        props.setValueInput(t('itemName'))
                        break;
                    case 'indice':
                        props.setValueInput(t('prmpIndice'))
                        break;
                    case 'provisoire':
                        props.setValueInput(t('temporaryItem'))
                        break;
                    case 'internalid':
                        props.setValueInput(t('internalId'))
                        break;
                    case 'havestock':
                        props.setValueInput(t('itemHaveStock'))
                        break;
                    case 'price':
                        props.setValueInput(t('priceTtcB2c'))
                        break;
                    case 'price_b2b':
                        props.setValueInput(t('priceHtB2b'))
                        break;
                    case 'ht':
                        props.setValueInput(t('priceHtB2c'))
                        break;
                    case 'price_b2b_ttc':
                        props.setValueInput(t('priceTtcB2b'))
                        break;
                    default:
                        if(t(label)){
                            props.setValueInput(t(label))
                        }else{
                            props.setValueInput(label)
                        }
                        break;
                }                
            }
            else props.setValueInput(label)
        }else{
            props.setValueInput('')
        }

        if(props.from && props.from=="selectITems"){
            props.setIds({name:label,id:id,quota:quota})

        }else if(props.from && props.from=="selectPo"){
            props.setIds(id)
            props.setValue('po',id)

        }else if(props.from && props.from=="selectEcomConnect"){
            props.setIds({name:label,id:id})

        }else{
            props.setIds([...props.ids,{name:label,id:id}])
            
        }

        if(props.callBackAfterSelect) props.callBackAfterSelect(id)

        listRef.current.classList.add("d-none")
        if(props.setDisabledValidSearch && props.blockSearchValid) props.setDisabledValidSearch(false)
    }

    const handleSearch = (e,declenchement) => {
        props.setValueInput(e.target.value);
        //si on fait une recherche sans cliquer sur une des propositions, on disabled le btn valider
        if(props.setDisabledValidSearch && props.blockSearchValid) props.setDisabledValidSearch(true)
        let ajour = props.datas.filter((value)=>value.name.toLowerCase().includes(e.target.value.toLowerCase()))
        setDatas(ajour)
    }

    const handleFocus = () => {
        setDatas(props.datas)
        listRef.current.classList.remove("d-none");
    }

    const handleBlur = () => {
        listRef.current.classList.add("d-none")
        if(props.setDisabledValidSearch && props.blockSearchValid) props.setDisabledValidSearch(false)
        //cela permet ne reécrire ce qu'il y avait avant 
        if(props.blockSearchValid) {
            switch (props.ids.name) {
                case 'name':
                    props.setValueInput(t('itemName'))
                    break;
                case 'indice':
                    props.setValueInput(t('prmpIndice'))
                    break;
                case 'provisoire':
                    props.setValueInput(t('temporaryItem'))
                    break;
                case 'internalid':
                    props.setValueInput(t('internalId'))
                    break;
                case 'havestock':
                    props.setValueInput(t('itemHaveStock'))
                    break;
                case 'price':
                    props.setValueInput(t('priceTtcB2c'))
                    break;
                case 'price_b2b':
                    props.setValueInput(t('priceHtB2b'))
                    break;
                case 'ht':
                    props.setValueInput(t('priceHtB2c'))
                    break;
                case 'price_b2b_ttc':
                    props.setValueInput(t('priceTtcB2b'))
                    break;
                default:
                    props.setValueInput(props.ids.name)
                    break;
            }
        }
    }

    return(
        <InpDataList
            placeholder="-- Select --"
            value={props.valueInput}
            onClick={handleClickFilter}
            onChange={handleSearch}
            datas={datas}
            declenchement={0}
            listRef={listRef}
            inputRef={inputRef}
            onFocus={handleFocus}
            onBlur={handleBlur}
            inputName={props.inputName}
            disabled={props.disabled}
            props={props.from}
        />
    )
}

export default SelectDataListSearch;